export class Dispatch {
  constructor(public id?,
              public shippingCompanyType?,
              public trackingNumber?,
              public dispatchTicket?,
              public observation?,
              public equipmentArrived?,
              public creationDate?,
              public lastUpdateDate?,
              public isEditable?,
              public isVisible?,
              public canView?,
              public canEdit?,
              public editable?,
              public argosUser?,
              public completed?,
              public shippingCost?,
              public arrivalEstimatedDate?,
              public arrivalRealDate?,
              public associateAutoeletric?) {}
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/dispatch.ts